module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Fork-b2644be68d1ab0ab5a740480da04947d.svg";